import { useCreateQuestionMutation } from '@/api/questions/createQuestion';
import { useUpdateQuestionMutation } from '@/api/questions/updateQuestion';
import { questionValidationSchema } from '@/validation/questionSchema';
import {
  QuestionFormValues,
  QuestionData,
  apiToFormValues,
  formValuesToCreatePayload,
  formValuesToUpdatePayload,
} from '@/utils/forms/questionTransformers';

interface UseQuestionFormProps {
  question?: QuestionData;
  questionId?: string;
  searchPickemId?: string;
  isNewQuestion: boolean;
}

export function useQuestionForm({
  question,
  questionId,
  searchPickemId,
  isNewQuestion,
}: UseQuestionFormProps) {
  const { mutate: createMutate, isPending: createIsPending } = useCreateQuestionMutation();
  const { mutate: updateMutate, isPending: updateIsPending } = useUpdateQuestionMutation();

  const initialValues = apiToFormValues(question, searchPickemId);

  const handleSubmit = (values: QuestionFormValues) => {
    console.log('🔵 useQuestionForm.handleSubmit called');
    console.log('Is New Question:', isNewQuestion);

    if (isNewQuestion) {
      console.log('Creating new question...');
      const payload = formValuesToCreatePayload(values);
      console.log('Create Payload:', JSON.stringify(payload, null, 2));
      createMutate(payload);
    } else {
      if (!questionId) {
        console.error('questionId is required for update');
        return;
      }
      console.log('Updating question:', questionId);
      const payload = formValuesToUpdatePayload(questionId, values);
      console.log('Update Payload:', JSON.stringify(payload, null, 2));
      updateMutate(payload);
    }
  };

  return {
    initialValues,
    validationSchema: questionValidationSchema,
    handleSubmit,
    isPending: createIsPending || updateIsPending,
  };
}
